module.exports = __webpack_public_path__ + "img/banbif.a77496ad.svg";